export default __webpack_public_path__ + "static/media/universe2.1621379b.png";